<template>
<div class="block">
    <div class="block_label">
        <label>{{ label }} :</label>
        <span>{{ currentActive.label }}</span>
    </div>
    <div class="over_flow" >
        <div class="block_flex" ref="scrollContainer">
            <div class="box text-center" v-for="item in props.option" :key="item.value" :class="{'active ': item.selected === 1, 'disabled': item.visibility === 0}" @click="addActive(item.value)">
                <div>
                    <img v-if="item.icon ==='white'" width="50" height="50" src="~/assets/metals/white.png" alt="white gold"/>
                    <img v-if="item.icon ==='yellow'" width="50" height="50" src="~/assets/metals/yellow.png" alt="yellow gold"/>
                    <img v-if="item.icon ==='rose'" width="50" height="50" src="~/assets/metals/rose.png" alt="rose gold"/>
                </div>    
                <!-- <SvgMetalSvg v-if="['metal'].includes(type)" :type="item.selected === 1 ? item.icon + '_active' : item.icon" /> -->
                <SvgShapeSvg v-if="['shape'].includes(type)" :type="item.icon + (item.selected === 1 ? '_active_green' : '')"/>
                <span v-if="['metal'].includes(type)" :type="item.icon" class="metal_label">{{ item.values.short_label}}</span> 
                <span v-else :class="{ 'border_box': item.icon === null , 'border_box-active': item.selected === 1 && item.icon === null}">{{ item.label }}</span>
            </div>
        </div>
    </div>
    
</div>
</template>


<script setup>
const scrollContainer = ref('')
const startX = ref(0);
const isDown = ref(false)
const scrollLeft = ref(0);
const props = defineProps ({
    type:String,
    label:String,
    option:Object,
})

const emit = defineEmits(['toggleOption'])

const currentActive = computed(() => {
    return props.option.find((item) => item.selected === 1)
})

const addActive = (value) => {
    props.option.filter((item) => {
        if(item.value === value) {
            item.selected = 1
        }else {
            item.selected = 0
        }
    })

    emit('toggleOption',props.type)
    
}

function initHorizontalScroll() {
    if(scrollContainer.value){
        const scroll_Container = scrollContainer.value;

        scroll_Container.addEventListener('mousedown', (e) => {
            isDown.value = true;
            startX.value = e.pageX - scroll_Container.offsetLeft;
            scrollLeft.value = scroll_Container.scrollLeft;
        });

        scroll_Container.addEventListener('mouseleave', () => {
            isDown.value = false;
        });

        scroll_Container.addEventListener('mouseup', () => {
            isDown.value = false;
        });

        scroll_Container.addEventListener('mousemove', (e) => {
            if (!isDown.value) return;
            e.preventDefault();
            const x = e.pageX - scroll_Container.offsetLeft;
            const walk = (x - startX.value) * 3; // Adjust scrolling speed here
            scroll_Container.scrollLeft = scrollLeft.value - walk;
        });
    }
}

onMounted(() => {
    initHorizontalScroll();   
})

</script>



<style scoped>

.block {
    /* border-bottom: 1px solid #f5f5f5; */
    /* border-top: 1px solid #f5f5f5; */
    /* padding: 8px 0; */
}
.block_label {
    display: flex;
    align-items: center;
}

.block_label label {
    text-transform: capitalize;
    font-weight: 600;
    font-size: 16px;
}

.box .metal_label{
    text-transform: uppercase;
}
.block_label span {
    text-transform: capitalize;
    font-weight: 600;
    color: var(--green);
    margin-left: 10px;
    font-size: 16px;
}

.block_flex {
    display: flex;
    align-items: flex-start;
    padding: 2% 0 0;
    gap: 20px;
    /* overflow-x: scroll; */
    overflow-y: hidden;
    padding-bottom: 2%;
}

/* width */
::-webkit-scrollbar {
    width: 2px;
    height: 3px;
}

/* Track */
.block_flex::-webkit-scrollbar-track {
    background: #f5f5f5; 
}

/* Handle */
.block_flex::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    
}

/* Handle on hover */
.block_flex::-webkit-scrollbar-thumb:hover {
    background: #c4c4c4; 
}

.box {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    /* gap: 6px; */
    align-items: center;
}

.box span {
    color: #606060;
    font-size: 14px;
    text-transform: capitalize;
    min-width: 46px;
    display: inline-block;
    text-align: center;
}

.box.active span {
    color: var(--green);
    font-weight: 600;
}

.border_box {
    border: 1px solid #c4c4c4;
    width: max-content;
    border-radius: 4px;
    padding: 8px 12px;
}

.border_box-active  {
    border: 1px solid var(--green);
}



@media(max-width: 1050px){
    .over_flow {
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .block_flex {
        min-width: 450px;
    }
}
@media(max-width: 767px){
    .block_label label,
    .block_label Span  {
        font-size: 14px;
    }

    .box span {
        font-size: 12px;
    }
    .block {
        border-bottom: 2px solid #f5f5f5;
        /* border-top: 2px solid #f5f5f5; */
        padding: 20px 0;
        /* padding-bottom: 18px; */
    }
    
    .block_flex {
       
        padding-bottom: 6px;
    }


}
</style>
